import React, { Component } from "react";
import { Row, Col, Button, Form, Select, message, Input, Checkbox } from "antd";
import "./Required.css";
import { withRouter } from "react-router-dom";
import { API } from "../../../API/API";
const { TextArea } = Input;
class RequiredAdd extends Component {
  formRef = React.createRef();
  state = {
    isEdit: this.props.isEdit,
    requireid: this.props.requireid,
    invitationid: this.props.invitationid,
    requiretypeid: null,
    requiretypelist: [],
    requirename: "",
    visible: true,
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getRequireInitialData?requireid=" + this.state.requireid).then(
      (response) => {
        if (response.status === 200) {
          if (response.data.retData.length > 0) {
            if (response.data.retData[0].length > 0){
              this.setState((prevState) => ({
                requirename: response.data.retData[0][0].requirename,
                visible: response.data.retData[0][0].visible === 1 ? true : false,
                requiretypeid: response.data.retData[0][0].requiretypeid,
                requiretypelist: response.data.retData[1],
                dkey: prevState.dkey + 1,
              }));
            }
            else {
              this.setState((prevState) => ({
                requiretypelist: response.data.retData[1],
                dkey: prevState.dkey + 1,
              }));
            }
          }
        }
      }
    );
  };
  onChangeValue = (e) => {
    this.setState({ requirename: e.target.value });
  };
  onChangeVisible = (e) => {
    this.setState({ visible: e.target.checked });
  };

  onChangeType = (e) => {
    this.setState({ requiretypeid: e });
  };

  onSave = () => {
    if (this.state.requiretypeid) {
      let body = {
        requireid: this.state.requireid,
        invitationid: this.state.invitationid,
        requirename: this.state.requirename,
        requiretypeid: this.state.requiretypeid,
        visible: this.state.visible ? 1 : 0,
      };
      API.post("/saveRequire", body).then((response) => {
        if (response.status === 200) {
          message.success("Амжилттай хадгаллаа.");
          this.props.showForm(false, 0);
        }
      });
    }
  };
  render() {
    const disabled = this.state.isEdit === true ? false : true;
    return (
      <div id="required" key={this.state.dkey}>
        <Form
          className="formDrawer"
          ref={this.formRef}
          onFinish={this.onSubmit}
          layout="vertical"
          initialValues={{}}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
            <Form.Item
                style={{ fontWeight: 600 }}
                label="Төрөл"
                name="requiretypeid"
                initialValue={this.state.requiretypeid}
                rules={[
                  {
                    required: true,
                    message: "Төрөл сонгоно уу.",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%", height: 30 }}
                  disabled={disabled}
                  showSearch
                  allowClear
                  optionFilterProp="name"
                  onChange={this.onChangeType}
                  defaultValue={this.state.requiretypeid}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.requiretypelist &&
                    this.state.requiretypelist?.map((t, i) => (
                      <Select.Option key={i} value={t.id}>
                        {t.requirevalue}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Урилга харуулах эсэх"
                name="visible"
                initialValue={this.state.visible ? true : false}
              >
                <Checkbox
                  disabled={disabled}
                  onChange={this.onChangeVisible}
                  defaultChecked={this.state.visible ? true : false}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item className="buttonForm" label=" ">
            <Button
              disabled={disabled}
              type="primary"
              style={{
                width: "100%",
                backgroundColor: "#0358A7",
                borderRadius: 2,
                height: 40,
              }}
              htmlType="submit"
              onClick={this.onSave}
            >
              Бүрдүүлэх материал нэмэх
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default withRouter(RequiredAdd);
